module.exports = __webpack_public_path__ + "img/5.76b1bbd7.png";